import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Wallet } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("demo@moneywise.ai");
  const [password, setPassword] = useState("Demo1234!");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name.split(" ")[0]}`);
      nav(u.onboarding_complete ? "/app" : "/onboarding");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <div className="max-w-md mx-auto w-full flex flex-col flex-1 px-6 py-10">
        <div className="flex items-center gap-2 mb-16">
          <div className="w-10 h-10 rounded-2xl bg-slate-900 text-white flex items-center justify-center">
            <Wallet size={20} strokeWidth={1.75} />
          </div>
          <div className="font-manrope font-bold text-lg tracking-tight text-slate-900">MoneyWise</div>
        </div>

        <h1 className="font-manrope text-4xl sm:text-5xl font-extrabold tracking-tighter text-slate-900 leading-none">Find your money.</h1>
        <p className="text-slate-500 mt-4 text-base leading-relaxed">Log in to see where your money is going and how much you could save.</p>

        <form onSubmit={submit} className="mt-10 space-y-4">
          <div>
            <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Email</label>
            <input
              data-testid="login-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-slate-900 focus:ring-2 focus:ring-slate-900 focus:border-transparent outline-none transition-colors duration-200"
            />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Password</label>
            <input
              data-testid="login-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-slate-900 focus:ring-2 focus:ring-slate-900 focus:border-transparent outline-none transition-colors duration-200"
            />
          </div>
          <Link to="/forgot" data-testid="forgot-link" className="block text-sm text-slate-500 hover:text-slate-900 transition-colors">Forgot password?</Link>
          <button
            data-testid="login-submit-btn"
            type="submit"
            disabled={busy}
            className="w-full bg-slate-900 text-white rounded-full py-4 font-semibold hover:bg-slate-800 active:scale-[0.98] transition-transform duration-150 disabled:opacity-60"
          >
            {busy ? "Signing in…" : "Continue"}
          </button>
        </form>

        <div className="mt-8 text-center text-sm text-slate-500">
          New here?{" "}
          <Link data-testid="signup-link" to="/signup" className="text-slate-900 font-semibold hover:underline">Create an account</Link>
        </div>

        <div className="mt-auto pt-10 text-xs text-slate-400 text-center leading-relaxed">
          MoneyWise provides educational insights based on your data. It is not a financial advisor.
        </div>
      </div>
    </div>
  );
}
